"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/happyjoe/happyjoe.scss');
const index_1 = require("./../js/index");
const happyjoe_1 = require("./../js/happyjoe");
const ProductsApp_happyjoe_1 = require("./ReactComponents/Products/ProductsApp-happyjoe");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Initialize HappyJoe specific scripts
(0, happyjoe_1.InitHappyJoe)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)(Object.assign(Object.assign({}, index_1.DefaultComponentTypes), { ProductsApp: ProductsApp_happyjoe_1.default }));
// Import site specific scripts
//require("./Sites/roseekellari");
